import React from 'react';

export type StatCardVariant = 'default' | 'success' | 'warning' | 'error';

export interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: number | string;
  variant?: StatCardVariant;
  onClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  variant = 'default',
  onClick,
}) => {
  return (
    <div
      className={`bdb-nc-stat-card${onClick ? ' is-clickable' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      <div className="bdb-nc-stat-content">
        <div className={`bdb-nc-stat-icon-box variant-${variant}`}>
          {icon}
        </div>
        <div className="bdb-nc-stat-text">
          <p className="bdb-nc-stat-label">{label}</p>
          <p className="bdb-nc-stat-value">
            {typeof value === 'number' ? value.toLocaleString() : value}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
